<template>
  <div class="content" id="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>
    <v-card>
      <v-card-title>
        Engajamento Detalhado
        <v-spacer></v-spacer>
        <v-flex xs1>
          <v-btn
            class="btn-block btn btn-secondary mb-2"
            @click="setFullScreen()"
          >
            <v-icon small class="black--text">fullscreen</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex xs4>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Procurar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4>
          <v-dialog
            ref="dialog_begin"
            v-model="modal_begin"
            :return-value.sync="begin_date"
            persistent
            lazy
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="begin_date"
                label="Período"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="begin_date" type="month">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_begin = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_begin.save(begin_date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2>
          <v-btn
            class="btn-block btn btn-primary mb-2 filtro-button"
            @click="filtrar()"
            >Filtrar</v-btn
          >
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-flex sm6 offset-sm10 offset-lg10>
        <download-excel
          class="ml-auto mr-0"
          :data="reservationGrid"
          :fields="json_fields"
          name="engajamento_detalhado.xls"
        >
          <v-btn small class="mr-4"
            ><span class="pr-1">Exportar</span
            ><v-icon small class="black--text">insert_drive_file</v-icon></v-btn
          >
        </download-excel>
      </v-flex>
      <br />
      <v-data-table
        id="table"
        no-data-text="nenhum dado encontrado"
        :headers="headers"
        :items="reservationGrid"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class>{{ item.name }}</td>
            <td class>{{ item.plate }}</td>
            <td class>{{ item.mobilizacao }}</td>
            <td class>{{ item.housing_unit }}</td>
            <td class>{{ item.nro_usuarios }}</td>
            <td class>{{ Math.round(item.n_moradores) }}</td>
            <td class>
              {{
                Math.round(
                  (item.nro_usuarios * 100) / Math.round(item.n_moradores)
                )
              }}
              %
            </td>
            <td class>{{ item.consultant }}</td>
            <td class>{{ item.meta_cond | formatValue }}</td>
            <td
              :class="setWeekColor(item, 'semana1')"
              v-if="item.faturamento.semana1"
            >
              {{ item.faturamento.semana1 | formatValue }}
            </td>
            <td :class="setWeekColor(item, 'semana1')" v-else>-</td>
            <td
              :class="setWeekColor(item, 'semana2')"
              v-if="item.faturamento.semana2"
            >
              {{ item.faturamento.semana2 | formatValue }}
            </td>
            <td :class="setWeekColor(item, 'semana2')" v-else>-</td>
            <td
              :class="setWeekColor(item, 'semana3')"
              v-if="item.faturamento.semana3"
            >
              {{ item.faturamento.semana3 | formatValue }}
            </td>
            <td :class="setWeekColor(item, 'semana3')" v-else>-</td>
            <td
              :class="setWeekColor(item, 'semana4')"
              v-if="item.faturamento.semana4"
            >
              {{ item.faturamento.semana4 | formatValue }}
            </td>
            <td :class="setWeekColor(item, 'semana4')" v-else>-</td>
            <td
              :class="setWeekColor(item, 'semana5')"
              v-if="item.faturamento.semana5"
            >
              {{ item.faturamento.semana5 | formatValue }}
            </td>
            <td :class="setWeekColor(item, 'semana5')" v-else>-</td>
            <td :class="setTotalMonthColor(item)">
              {{ item.total_mes | formatValue }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import moment from 'moment';
import Roles from '../../models/Roles';

export default {
  data() {
    return {
      profile: localStorage.getItem('profile'),
      header_color: 'blue',
      begin_date: moment().format('YYYY-MM'),
      modal_begin: false,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      reservationGrid: [],
      service: null,
      search: '',
      pagination: {
        sortBy: 'cliente',
        descending: true,
      },
      headers: [
        { text: 'Condomínio', value: 'name' },
        { text: 'Placa', value: 'plate' },
        { text: 'Mobilização', value: 'mobilizacao' },
        { text: 'Nº Unidades', value: 'housing_unit' },
        { text: 'Nº Usuários', value: 'nro_usuarios' },
        { text: 'Nº Moradores', value: 'n_moradores' },
        { text: '% Usuários ativos', value: 'active_users' },
        { text: 'Consultor', value: 'consultant' },
        { text: 'Meta do cond./mês', value: 'meta_cond' },
        { text: '1ª semana', value: 'faturamento.semana1' },
        { text: '2ª semana', value: 'faturamento.semana2' },
        { text: '3ª semana', value: 'faturamento.semana3' },
        { text: '4ª semana', value: 'faturamento.semana4' },
        { text: '5ª semana', value: 'faturamento.semana5' },
        { text: 'Total mês', value: 'total_mes' },
      ],
      json_fields: {
        Condomínio: 'name',
        Placa: 'plate',
        Mobilização: 'mobilizacao',
        'Nº Unidades': 'housing_unit',
        'Nº Usuários': 'nro_usuarios',
        'Nº Moradores': {
          field: 'n_moradores',
          callback: (value) => {
            return Math.round(value);
          },
        },
        '% Usuários Ativos': {
          callback: (value) => {
            return `${Math.round(
              (value.nro_usuarios * 100) / Math.round(value.n_moradores)
            )}%`;
          },
        },
        Consultor: 'consultant',
        'Meta do cond./mês': {
          field: 'meta_cond',
          callback: (value) => {
            return value ? this.formatValue(value) : '-';
          },
        },
        '1ª semana': {
          field: 'faturamento.semana1',
          callback: (value) => {
            return value ? this.formatValue(value) : '-';
          },
        },
        '2ª semana': {
          field: 'faturamento.semana2',
          callback: (value) => {
            return value ? this.formatValue(value) : '-';
          },
        },
        '3ª semana': {
          field: 'faturamento.semana3',
          callback: (value) => {
            return value ? this.formatValue(value) : '-';
          },
        },
        '4ª semana': {
          field: 'faturamento.semana4',
          callback: (value) => {
            return value ? this.formatValue(value) : '-';
          },
        },
        '5ª semana': {
          field: 'faturamento.semana5',
          callback: (value) => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'Total mês': {
          field: 'total_mes',
          callback: (value) => {
            return this.formatValue(value);
          },
        },
      },
      fullScreen: false,
      vehicleRequestController: new VehicleRequestController(this.$resource),
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    filtrar() {
      this.loadData();
    },

    async loadData() {
      this.blockScreen = true;
      try {
        let response = null;
        if (this.profile == Roles.Tcs) {
          response =
            await this.vehicleRequestController.getDetailedEngagementReport(
              this.begin_date
            );
        }
        if (response.ok) {
          this.reservationGrid = response.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.blockScreen = false;
      }
    },

    setWeekColor(item, semana) {
      const meta_semana = item.meta_cond / 5;

      if (
        meta_semana * 0.6 >= item.faturamento[semana] ||
        !item.faturamento[semana]
      )
        return 'red lighten-2';
      if (
        meta_semana * 0.61 <= item.faturamento[semana] &&
        item.faturamento[semana] <= meta_semana * 0.99
      )
        return 'yellow lighten-2';
      if (
        meta_semana * 1.0 <= item.faturamento[semana] &&
        item.faturamento[semana] <= meta_semana * 1.1
      )
        return 'green lighten-2';
      if (meta_semana * 1.11 <= item.faturamento[semana])
        return 'blue lighten-2';
    },

    setTotalMonthColor(item) {
      if (item.meta_cond * 0.6 >= item.total_mes || !item.total_mes)
        return 'red lighten-2';
      if (
        item.meta_cond * 0.61 <= item.total_mes &&
        item.total_mes <= item.meta_cond * 0.99
      )
        return 'yellow lighten-2';
      if (
        item.meta_cond * 1.0 <= item.total_mes &&
        item.total_mes <= item.meta_cond * 1.1
      )
        return 'green lighten-2';
      if (item.meta_cond * 1.11 <= item.total_mes) return 'blue lighten-2';
      return 'transparent';
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },

    setFullScreen() {
      if (!this.fullScreen) {
        document.getElementById('content').classList.add('full-screen');
        document.getElementById('table').classList.add('table-full-screen');
      } else {
        document.getElementById('content').classList.remove('full-screen');
        document.getElementById('table').classList.remove('table-full-screen');
      }
      this.fullScreen = !this.fullScreen;
    },
  },
  filters: {
    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },

    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).locale('pt-br').format('MMMM[ de ]YYYY');
      }
    },
  },
};
</script>

<style lang="scss">
.action-list button {
  float: right;
}
.table-custom-vue {
  margin: 20px;
}
.filtro-button {
  background: var(--primary-color-hover) !important;
}
.full-screen {
  width: 100vw;
  height: 100vh;
  padding: 0 !important;
  z-index: 7;
  position: absolute;
  top: 0;
  margin: 0;
}
.table-full-screen {
  height: 100vh;
  .v-data-table__wrapper {
    background: white;
  }
  .v-data-footer {
    background: white;
  }
}
</style>
